"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createText = void 0;
var react_1 = require("react");
var assert_1 = require("tsafe/assert");
var compat_1 = require("tss-react/compat");
function createText(params) {
    var useTheme = params.useTheme;
    var makeStyles = compat_1.createMakeStyles({ useTheme: useTheme }).makeStyles;
    var Text = react_1.memo(react_1.forwardRef(function (props, ref) {
        var className = props.className, children = props.children, typo = props.typo, _a = props.color, color = _a === void 0 ? "primary" : _a, htmlComponent = props.htmlComponent, _b = props.componentProps, componentProps = _b === void 0 ? {} : _b, _c = props.fixedSize_enabled, fixedSize_enabled = _c === void 0 ? false : _c, fixedSize_content = props.fixedSize_content, fixedSize_fontWeight = props.fixedSize_fontWeight, 
        //For the forwarding, rest should be empty (typewise)
        rest = __rest(props, ["className", "children", "typo", "color", "htmlComponent", "componentProps", "fixedSize_enabled", "fixedSize_content", "fixedSize_fontWeight"]);
        //For the forwarding, rest should be empty (typewise),
        // eslint-disable-next-line @typescript-eslint/ban-types
        assert_1.assert();
        var theme = useTheme();
        var _d = useStyles({
            typo: typo,
            color: color,
            fixedSize_enabled: fixedSize_enabled,
            fixedSize_content: fixedSize_content,
            fixedSize_fontWeight: fixedSize_fontWeight,
            "children": typeof children === "string"
                ? children
                : undefined,
        }), classes = _d.classes, cx = _d.cx;
        return react_1.createElement(htmlComponent !== null && htmlComponent !== void 0 ? htmlComponent : theme.typography.variants[typo].htmlComponent, __assign(__assign({ "className": cx(classes.root, className), ref: ref }, componentProps), rest), children);
    }));
    var useStyles = makeStyles({ "name": "Text" })(function (theme, _a) {
        var typo = _a.typo, color = _a.color, fixedSize_enabled = _a.fixedSize_enabled, fixedSize_fontWeight = _a.fixedSize_fontWeight, fixedSize_content = _a.fixedSize_content, children = _a.children;
        return ({
            "root": __assign(__assign(__assign({}, theme.typography.variants[typo].style), { "color": theme.colors.useCases.typography[(function () {
                    switch (color) {
                        case "primary":
                            return "textPrimary";
                        case "secondary":
                            return "textSecondary";
                        case "disabled":
                            return "textDisabled";
                        case "focus":
                            return "textFocus";
                    }
                })()], "padding": 0, "margin": 0 }), (!fixedSize_enabled
                ? {}
                : {
                    "display": "inline-flex",
                    "flexDirection": "column",
                    "alignItems": "center",
                    "justifyContent": "space-between",
                    "&::after": {
                        "content": fixedSize_content
                            ? "\"" + fixedSize_content + "\""
                            : (assert_1.assert(children !== undefined),
                                "\"" + children + "_\""),
                        "height": 0,
                        "visibility": "hidden",
                        "overflow": "hidden",
                        "userSelect": "none",
                        "pointerEvents": "none",
                        "fontWeight": fixedSize_fontWeight,
                        "@media speech": {
                            "display": "none",
                        },
                    },
                })),
        });
    });
    return { Text: Text };
}
exports.createText = createText;
//# sourceMappingURL=Text.js.map